import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, CheckIcon, DropletIcon, SparklesIcon, FlowerIcon, ClockIcon, SunIcon, LeafIcon, HeartIcon, PaletteIcon, BookOpenIcon, AwardIcon, ShieldCheckIcon } from 'lucide-react';
import { WaveDivider } from './components/WaveDivider';
import { CtaButton } from './components/CtaButton';
import { PriceBlock } from './components/PriceBlock';
import { BonusCard } from './components/BonusCard';
import { Testimonial } from './components/Testimonial';
import { FaqItem } from './components/FaqItem';
import { GuaranteeSeal } from './components/GuaranteeSeal';
const HERO_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/6fe84d88-2669-49ad-8cf2-157881866da9.jpg';
const METHOD_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/42d59eb3-2234-4e5c-a3c0-10ff5a7d50ef.jpg';
const AVATAR_1 = 'https://cdn.magicpatterns.com/patterns/generated-images/73ca7aa6-3847-4024-ab26-8929fbc3adb4.jpg';
const AVATAR_2 = 'https://cdn.magicpatterns.com/patterns/generated-images/5283662c-901d-4a24-a730-14b083ccee2c.jpg';
const BENEFITS = ['Aprende formulación terapéutica real para crear jabones con beneficios comprobados para la piel.', 'Lanza tu propia línea de jabones artesanales paso a paso, sin sentirte perdida ni saturada.', 'Accede a una lista de proveedores verificados de ingredientes y materiales de calidad.', 'Recibe 30 fórmulas exclusivas listas para producir y vender desde el primer día.', 'Crea jabones con beneficios reales para la piel, no solo bonitos por fuera.', 'Reduce el desperdicio y baja tus costos de producción con procesos eficientes.', 'Da a tus productos una presentación profesional que enamora y justifica su precio.', 'Diferénciate por el valor terapéutico de tu marca, no por competir en precio.'];
const PILLARS = [{
  icon: LeafIcon,
  title: 'Propiedades reales de los ingredientes',
  text: 'Conoce qué aporta cada aceite, manteca y activo natural para formular con intención, no por moda.'
}, {
  icon: DropletIcon,
  title: 'Formulación consciente',
  text: 'Aprende a combinar ingredientes de forma segura y balanceada para resultados terapéuticos consistentes.'
}, {
  icon: PaletteIcon,
  title: 'Presentación atractiva',
  text: 'Empaques, etiquetas y estética que convierten un jabón en un producto que la gente desea regalar.'
}, {
  icon: HeartIcon,
  title: 'Enfoque emocional de venta',
  text: 'Vende la transformación y el bienestar que ofreces, conectando con lo que tu clienta realmente busca.'
}];
const RECIPES = [{
  icon: DropletIcon,
  title: 'Hidratación piel seca',
  text: 'Fórmulas nutritivas con mantecas y aceites que restauran la barrera de la piel.'
}, {
  icon: SparklesIcon,
  title: 'Control de acné',
  text: 'Jabones purificantes con activos que ayudan a equilibrar la piel grasa.'
}, {
  icon: FlowerIcon,
  title: 'Relajación y aromaterapia',
  text: 'Mezclas de aceites esenciales para calmar cuerpo y mente en cada baño.'
}, {
  icon: ClockIcon,
  title: 'Anti-edad',
  text: 'Recetas con antioxidantes que aportan firmeza y luminosidad a la piel madura.'
}, {
  icon: LeafIcon,
  title: 'Exfoliante natural',
  text: 'Texturas suaves con exfoliantes botánicos para renovar la piel sin agredirla.'
}, {
  icon: SunIcon,
  title: 'Después del sol y del afeitado',
  text: 'Fórmulas calmantes que alivian, hidratan y refrescan la piel irritada.'
}];
const BONUSES = [{
  title: 'Lista de proveedores verificada',
  description: 'Directorio actualizado de proveedores confiables de ingredientes y materiales de calidad.'
}, {
  title: 'Plantillas de etiquetas para imprimir',
  description: 'Diseños editables y listos para imprimir que dan un acabado profesional a tus jabones.'
}, {
  title: 'Acompañamiento en plataforma virtual',
  description: 'Comunidad y seguimiento en línea para resolver tus dudas mientras avanzas en el curso.'
}, {
  title: 'Guía de empaques ecológicos',
  description: 'Ideas y proveedores de empaques sostenibles que refuerzan el valor de tu marca.'
}, {
  title: 'Fórmulas simples para tus primeras ventas',
  description: 'Muestras y fórmulas fáciles para empezar a producir y vender de inmediato.'
}, {
  title: 'Guía de kits de regalo artesanal',
  description: 'Aprende a armar kits de regalo irresistibles que aumentan tu ticket promedio.'
}];
const TESTIMONIALS = [{
  name: 'María Fernanda',
  avatar: AVATAR_1,
  time: '9:41',
  message: '¡Gracias! Hice mi primer lote siguiendo las fórmulas y mis amigas ya me hicieron 8 pedidos 🥹 nunca imaginé venderlos tan rápido.'
}, {
  name: 'Carolina R.',
  avatar: AVATAR_2,
  time: '14:22',
  message: 'El curso es súper claro, sin tecnicismos raros. La lista de proveedores sola ya vale muchísimo más de lo que pagué 🙌'
}, {
  name: 'Lucía Méndez',
  avatar: AVATAR_1,
  time: '20:07',
  message: 'Pasé de regalar jabones a tener mi propia marquita 💚 la parte de presentación y empaques me cambió todo. ¡Gracias de corazón!'
}];
const FAQS = [{
  question: '¿Cuánto dura el curso?',
  answer: 'El curso es 100% a tu ritmo. Puedes completarlo en pocos días o tomarte las semanas que necesites; las lecciones son cortas y prácticas.'
}, {
  question: '¿Necesito experiencia previa?',
  answer: 'No. El método está diseñado para empezar desde cero. Te llevamos de la mano desde los conceptos básicos hasta tus primeras ventas.'
}, {
  question: '¿Cómo accedo después de comprar?',
  answer: 'Justo después de tu pago recibirás por correo tus datos de acceso a la plataforma virtual, donde encontrarás todo el contenido y los bonos.'
}, {
  question: '¿Qué materiales necesito?',
  answer: 'Solo ingredientes básicos y utensilios de cocina fáciles de conseguir. Dentro del curso te indicamos exactamente qué comprar y con qué proveedores.'
}, {
  question: '¿Por cuánto tiempo tengo acceso?',
  answer: 'El acceso es de por vida. Podrás repasar las lecciones y consultar las fórmulas siempre que quieras, incluso las actualizaciones futuras.'
}, {
  question: '¿Qué métodos de pago aceptan?',
  answer: 'Aceptamos tarjetas Visa, Mastercard, American Express y PayPal. El cobro se realiza en dólares y se convierte a tu moneda local automáticamente.'
}, {
  question: '¿Es seguro el pago?',
  answer: 'Totalmente. El pago se procesa en una pasarela encriptada y segura. Además cuentas con nuestra garantía de satisfacción de 7 días.'
}];
export function App() {
  return <div className="w-full bg-cream text-ink" data-id="element-0" data-mp="2kp534qvpgurm">
      {/* 1. Banner de alerta */}
      <div className="bg-sage-deep px-4 py-2.5 text-center" data-id="element-1" data-mp="2fqadp638g7yj">
        <p className="mx-auto flex max-w-4xl items-center justify-center gap-2 text-xs font-extrabold uppercase leading-tight tracking-wide text-white sm:text-sm" data-id="element-2" data-mp="2tiqjgeniqk35">
          <AlertTriangleIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" data-id="element-3" data-mp="2phyaznmh0j7x" />
          Atención: Descuento relámpago + 6 bonos gratis para las primeras inscritas
        </p>
      </div>

      {/* 2. Hero */}
      <header className="bg-cream" data-id="element-4" data-mp="2yfqgy16ayein">
        <div className="mx-auto grid max-w-6xl items-center gap-8 px-5 py-10 md:grid-cols-2 md:gap-12 md:py-16" data-id="element-5" data-mp="3i33f9av0yctt">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="order-2 md:order-1" data-id="element-6" data-mp="3n2zfr04ijm4m">
            <span className="inline-block rounded-full bg-sage/15 px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-sage-deep" data-id="element-7" data-mp="3d3igp1jro6hm">
              Método Esencia Viva™
            </span>
            <h1 className="mt-4 font-serif text-3xl font-bold leading-tight text-ink sm:text-4xl md:text-[2.7rem]" data-id="element-8" data-mp="344wzb9q16xif">
              Crea y Vende desde Casa Tu Propia Línea de Jabones Artesanales Terapéuticos y
              Triplica tus Ventas con el Método{' '}
              <span className="text-sage-deep" data-id="element-9" data-mp="2ge9clibgi3bt">"Esencia Viva™"</span>
            </h1>
            <p className="mt-5 text-base leading-relaxed text-ink/70 sm:text-lg" data-id="element-10" data-mp="2ggn6hnueh9hs">
              Aprende a formular jabones naturales con beneficios reales para la piel, reduce
              tus costos de producción y convierte un arte hecho a mano en un negocio rentable
              desde la comodidad de tu hogar.
            </p>
            <div className="mt-7 max-w-sm" data-id="element-11" data-mp="2qwoar55lumzy">
              <CtaButton data-id="element-12" data-mp="2qvcx8dmcy0vn">Quiero registrarme ahora</CtaButton>
            </div>
            <p className="mt-3 text-xs font-semibold uppercase tracking-wide text-ink/50" data-id="element-13" data-mp="2lxbejtsug3kp">
              Cupos limitados · Precio de pre lanzamiento
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="order-1 md:order-2" data-id="element-14" data-mp="2d5jb4328lupm">
            <img src={HERO_IMG} alt="Mujer emprendedora sonriendo mientras sostiene jabones artesanales hechos a mano en su taller" className="mx-auto w-full max-w-md rounded-3xl shadow-xl shadow-ink/10" data-id="element-15" data-mp="239g7stvnfq13" />
          </motion.div>
        </div>
      </header>

      <WaveDivider fill="#ffffff" data-id="element-16" data-mp="9qz3quc4lxq7" />

      {/* 3. Lista de beneficios */}
      <section className="bg-white" data-id="element-17" data-mp="dp6i5ij4amy8">
        <div className="mx-auto max-w-4xl px-5 py-12 md:py-16" data-id="element-18" data-mp="dsccbc6lsf0t">
          <h2 className="text-center font-serif text-2xl font-bold text-ink sm:text-3xl" data-id="element-19" data-mp="iq41hyfv5n1b">
            Esto es lo que vas a lograr con el método
          </h2>
          <ul className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-20" data-mp="3m6tadr2x58u5">
            {BENEFITS.map(b => <li key={b} className="flex items-start gap-3 rounded-2xl bg-cream/70 p-4" data-id="element-21" data-mp="3r54gpru0917m">
                <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-sage text-white" data-id="element-22" data-mp="3w4qx2a54qxkn">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-23" data-mp="4quwzw10shd6" />
                </span>
                <span className="text-sm leading-relaxed text-ink/80 sm:text-base" data-id="element-24" data-mp="33gl9zgqlswhn">{b}</span>
              </li>)}
          </ul>
        </div>
      </section>

      <WaveDivider fill="#f7f1e6" data-id="element-25" data-mp="2f759n07a05e5" />

      {/* 4. Método + storytelling + pilares */}
      <section className="bg-cream" data-id="element-26" data-mp="2f9hnp29wxvlx">
        <div className="mx-auto max-w-5xl px-5 py-12 md:py-16" data-id="element-27" data-mp="2k5osgrqkp12a">
          <div className="grid items-center gap-8 md:grid-cols-2 md:gap-12" data-id="element-28" data-mp="2k81d5cnptpj1">
            <img src={METHOD_IMG} alt="Manos de mujer vertiendo jabón natural en moldes rodeada de hierbas y aceites esenciales" className="w-full rounded-3xl shadow-lg shadow-ink/10" data-id="element-29" data-mp="2p62rxle3z2op" />
            <div data-id="element-30" data-mp="21fgwctlajavl">
              <span className="inline-block rounded-full bg-sage/15 px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-sage-deep" data-id="element-31" data-mp="21exgdif7awk7">
                Mi historia
              </span>
              <h2 className="mt-4 font-serif text-2xl font-bold text-ink sm:text-3xl" data-id="element-32" data-mp="2b61uyh0ysfei">
                De una crisis personal a un método que hoy cambia vidas
              </h2>
              <div className="mt-4 space-y-3 text-sm leading-relaxed text-ink/70 sm:text-base" data-id="element-33" data-mp="1ip8yapwg7am9">
                <p data-id="element-34" data-mp="3vzig1ts69lkp">
                  Hace unos años atravesé una de mis peores crisis: sin trabajo estable y con la
                  piel castigada por productos llenos de químicos. Buscando alivio, descubrí el
                  jabón artesanal… y todo cambió.
                </p>
                <p data-id="element-35" data-mp="3n0wzu5a6ain3">
                  Empecé a formular jabones naturales para mí. Pronto, <strong data-id="element-36" data-mp="3hz7p6qqv46zj">todas querían
                  comprarme</strong>: amigas, vecinas, familia. Lo que nació como un remedio se
                  convirtió en una fuente de ingresos.
                </p>
                <p data-id="element-37" data-mp="388msx9ynvejs">
                  Así ordené todo lo que aprendí en el <strong data-id="element-38" data-mp="347jfeu435ulq">Método Esencia Viva™</strong>, para
                  que tú también puedas crear jabones con propósito y venderlos con confianza.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-12" data-id="element-39" data-mp="2u9n5g5mvx5p7">
            <h3 className="text-center font-serif text-xl font-bold text-ink sm:text-2xl" data-id="element-40" data-mp="2ubzjw8tfoxxi">
              Los 4 pilares del Método Esencia Viva™
            </h3>
            <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-41" data-mp="2fmod88g7e79f">
              {PILLARS.map((p, i) => {
              const Icon = p.icon;
              return <motion.div key={p.title} initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true,
                amount: 0.3
              }} transition={{
                duration: 0.4,
                delay: i * 0.08
              }} className="flex h-full flex-col rounded-2xl border border-cream-deep bg-white p-6 text-center" data-id="element-42" data-mp="26nta558ghdac" data-mpi={i}>
                    <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-sage/15 text-sage-deep" data-id="element-43" data-mp="2pldovjhiavh8">
                      <Icon className="h-6 w-6" aria-hidden="true" data-id="element-44" data-mp="3hctku44yduk4" />
                    </span>
                    <h4 className="mt-4 font-serif text-base font-bold text-ink" data-id="element-45" data-mp="3m3i9zct5ufg3">{p.title}</h4>
                    <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-46" data-mp="3m5cu4owly3j4">{p.text}</p>
                  </motion.div>;
            })}
            </div>
          </div>
        </div>
      </section>

      <WaveDivider fill="#ffffff" data-id="element-47" data-mp="1ke303uv52spg" />

      {/* 5. Grid de categorías de recetas */}
      <section className="bg-white" data-id="element-48" data-mp="1kg70i2ttx9kz">
        <div className="mx-auto max-w-5xl px-5 py-12 md:py-16" data-id="element-49" data-mp="1fezv2af5smhh">
          <h2 className="text-center font-serif text-2xl font-bold text-ink sm:text-3xl" data-id="element-50" data-mp="rpp0xbsbdqcb">
            30 fórmulas repartidas en 6 categorías de recetas
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-sm leading-relaxed text-ink/70 sm:text-base" data-id="element-51" data-mp="ms5eholgq79a">
            Todas listas para producir, con instrucciones claras y beneficios reales para cada
            tipo de piel.
          </p>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-52" data-mp="2d2rtt8tv7vr6">
            {RECIPES.map((r, i) => {
            const Icon = r.icon;
            return <motion.div key={r.title} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.3
            }} transition={{
              duration: 0.4,
              delay: i % 3 * 0.08
            }} className="flex h-full flex-col rounded-2xl bg-cream/70 p-6" data-id="element-53" data-mp="2861guudcxg9z" data-mpi={i}>
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-sage text-white" data-id="element-54" data-mp="vkhzmlk3wbgp">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-55" data-mp="10juw7y0s4wwh" />
                  </span>
                  <h3 className="mt-4 font-serif text-lg font-bold text-ink" data-id="element-56" data-mp="15inzkxmcr7ix">{r.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-57" data-mp="1acacmqwfhdf9">{r.text}</p>
                </motion.div>;
          })}
          </div>
        </div>
      </section>

      <WaveDivider fill="#f7f1e6" data-id="element-58" data-mp="1jdqgsgwngjb1" />

      {/* 6. Bloque de precio */}
      <section className="bg-cream" data-id="element-59" data-mp="1oagwh34jlcvx">
        <div className="mx-auto max-w-5xl px-5 py-12 md:py-16" data-id="element-60" data-mp="1objioxqx6r5i">
          <h2 className="mb-8 text-center font-serif text-2xl font-bold text-ink sm:text-3xl" data-id="element-61" data-mp="1yg8b1hwm1bjz">
            Empieza hoy por una fracción de su valor
          </h2>
          <PriceBlock id="registro" data-id="element-62" data-mp="1oh11l5szy125" />
        </div>
      </section>

      <WaveDivider fill="#ffffff" data-id="element-63" data-mp="1ohap8mqkjw4o" />

      {/* 7. Bonos gratis */}
      <section className="bg-white" data-id="element-64" data-mp="1kgh3o00lmtey">
        <div className="mx-auto max-w-5xl px-5 py-12 md:py-16" data-id="element-65" data-mp="1khif45lj1hx7">
          <div className="text-center" data-id="element-66" data-mp="2h4n2256xgpks">
            <span className="inline-block rounded-full bg-sage/15 px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-sage-deep" data-id="element-67" data-mp="2h7su9taus7kq">
              Solo por el pre lanzamiento
            </span>
            <h2 className="mt-4 font-serif text-2xl font-bold text-ink sm:text-3xl" data-id="element-68" data-mp="27dinh6l5z6qh">
              6 bonos gratis para acelerar tus primeras ventas
            </h2>
          </div>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-69" data-mp="2zxh64430ixa8">
            {BONUSES.map((b, i) => <BonusCard key={b.title} number={i + 1} title={b.title} description={b.description} data-id="element-70" data-mp="2v3d1vsl4t3cu" data-mpi={i} />)}
          </div>
        </div>
      </section>

      <WaveDivider fill="#f7f1e6" data-id="element-71" data-mp="y5ywhae1e31o" />

      {/* 8. Repetir bloque de precio */}
      <section className="bg-cream" data-id="element-72" data-mp="jinmve1f0t47">
        <div className="mx-auto max-w-5xl px-5 py-12 md:py-16" data-id="element-73" data-mp="jhktmzgmeel4">
          <h2 className="mb-8 text-center font-serif text-2xl font-bold text-ink sm:text-3xl" data-id="element-74" data-mp="ogfd83mew76a">
            Llévate el curso + los 6 bonos hoy mismo
          </h2>
          <PriceBlock data-id="element-75" data-mp="ajsepwet98y9" />
        </div>
      </section>

      <WaveDivider fill="#ffffff" data-id="element-76" data-mp="fhaeoxauodu4" />

      {/* 9. Testimonios estilo chat */}
      <section className="bg-white" data-id="element-77" data-mp="jrvsbkusuul">
        <div className="mx-auto max-w-2xl px-5 py-12 md:py-16" data-id="element-78" data-mp="kt78h5s7jcu">
          <h2 className="text-center font-serif text-2xl font-bold text-ink sm:text-3xl" data-id="element-79" data-mp="5hjkkwq7c0uk">
            Lo que dicen nuestras alumnas
          </h2>
          <div className="mt-8 space-y-4" data-id="element-80" data-mp="1uv6iejikie64">
            {TESTIMONIALS.map(t => <Testimonial key={t.name + t.time} {...t} data-id="element-81" data-mp="1zvubdaqcx52z" />)}
          </div>
        </div>
      </section>

      <WaveDivider fill="#f7f1e6" data-id="element-82" data-mp="3kcbvoa7hdf78" />

      {/* 10. Certificado */}
      <section className="bg-cream" data-id="element-83" data-mp="3fgmq9q8s5430">
        <div className="mx-auto max-w-4xl px-5 py-12 md:py-16" data-id="element-84" data-mp="3fdh0s9w8o06r">
          <div className="grid items-center gap-8 rounded-3xl border border-cream-deep bg-white p-8 md:grid-cols-[auto,1fr] md:gap-10 md:p-10" data-id="element-85" data-mp="3u4zn0pfoyqyk">
            <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full bg-gold/15 text-center" data-id="element-86" data-mp="6zi5lah3ciub">
              <AwardIcon className="h-12 w-12 text-gold" aria-hidden="true" data-id="element-87" data-mp="2yok0nr4fg4l" />
            </div>
            <div className="text-center md:text-left" data-id="element-88" data-mp="gy7nv4cwg5b3">
              <h2 className="font-serif text-2xl font-bold text-ink sm:text-3xl" data-id="element-89" data-mp="gvli9a9kjzvi">
                Recibe tu certificado al finalizar
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-ink/70 sm:text-base" data-id="element-90" data-mp="2io9hl8j3e360">
                Al completar el Método Esencia Viva™ obtendrás un certificado digital que respalda
                tu formación en jabonería artesanal terapéutica. Úsalo para dar confianza a tus
                clientas y posicionar tu marca con profesionalismo.
              </p>
            </div>
          </div>
        </div>
      </section>

      <WaveDivider fill="#ffffff" data-id="element-91" data-mp="21n3wco8sh023" />

      {/* 11. Garantía grande + precio */}
      <section className="bg-white" data-id="element-92" data-mp="26knbdqdb9gv3">
        <div className="mx-auto max-w-5xl px-5 py-12 md:py-16" data-id="element-93" data-mp="26nrkn25mv2sm">
          <div className="mx-auto max-w-3xl rounded-3xl border-2 border-sage/30 bg-cream/60 p-8 text-center md:p-10" data-id="element-94" data-mp="18z835tifhqa2">
            <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-sage text-white" data-id="element-95" data-mp="1dx9m8efutplj">
              <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-96" data-mp="1iygtmce34mro" />
            </div>
            <h2 className="font-serif text-3xl font-bold text-sage-deep sm:text-4xl" data-id="element-97" data-mp="1nt48djjae2t2">
              100% Segura
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-ink/70 sm:text-base" data-id="element-98" data-mp="2za3zwcxt8dm1">
              Tu compra está protegida con nuestra <strong data-id="element-99" data-mp="nlz7r13zd4em">garantía de satisfacción de 7 días</strong>.
              Si el curso no es para ti, te devolvemos el 100% de tu dinero sin preguntas ni
              complicaciones. El riesgo es todo nuestro.
            </p>
            <div className="mt-6 flex justify-center" data-id="element-100" data-mp="dv4hllnm5knw">
              <GuaranteeSeal data-id="element-101" data-mp="8yw56g0sw5kf" />
            </div>
          </div>

          <div className="mt-12" data-id="element-102" data-mp="3z1g8i0l5q20">
            <PriceBlock data-id="element-103" data-mp="3z9sc7ovwrc5" />
          </div>
        </div>
      </section>

      <WaveDivider fill="#f7f1e6" data-id="element-104" data-mp="3w32bfa3mm3nj" />

      {/* 12. FAQ */}
      <section className="bg-cream" data-id="element-105" data-mp="3w1iudha5bokp">
        <div className="mx-auto max-w-3xl px-5 py-12 md:py-16" data-id="element-106" data-mp="3r3pm8ipa8khs">
          <h2 className="text-center font-serif text-2xl font-bold text-ink sm:text-3xl" data-id="element-107" data-mp="3r3zg4hdg7bsr">
            Preguntas frecuentes
          </h2>
          <div className="mt-8 space-y-3" data-id="element-108" data-mp="1pc4769iktle8">
            {FAQS.map(f => <FaqItem key={f.question} question={f.question} answer={f.answer} data-id="element-109" data-mp="1pa07y4vmhaka" />)}
          </div>
        </div>
      </section>

      {/* 13. Footer */}
      <footer className="bg-sage-deep px-5 py-10 text-center" data-id="element-110" data-mp="2c617bvxc24aw">
        <div className="mx-auto max-w-3xl" data-id="element-111" data-mp="277pvjfnh9jq1">
          <p className="flex items-center justify-center gap-2 font-serif text-lg font-bold text-white" data-id="element-112" data-mp="278rfyaqdvikf">
            <BookOpenIcon className="h-5 w-5" aria-hidden="true" data-id="element-113" data-mp="22fq2m75trr2y" />
            Método Esencia Viva™
          </p>
          <p className="mt-4 text-xs leading-relaxed text-white/70" data-id="element-114" data-mp="1xgls9d75znb1">
            Este sitio no forma parte del sitio web de Facebook o Facebook Inc. Además, este sitio
            no está avalado por Facebook / Meta de ninguna manera. FACEBOOK es una marca registrada
            de Meta Platforms, Inc.
          </p>
          <p className="mt-4 text-xs text-white/60" data-id="element-115" data-mp="1ejlq8v8tj8nv">
            © {new Date().getFullYear()} Método Esencia Viva™. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}